/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BREEDER v2 API
 * OpenAPI spec version: 2.0.0
 */

export type Op = typeof Op[keyof typeof Op];


export const Op = {
  eq: 'eq',
  ne: 'ne',
  lt: 'lt',
  le: 'le',
  gt: 'gt',
  ge: 'ge',
  between: 'between',
  contains: 'contains',
  not_contains: 'not_contains',
  starts: 'starts',
  like: 'like',
  in: 'in',
  empty: 'empty',
  not_empty: 'not_empty',
} as const;
